import { INavModuleConfig } from '@mt-ng2/nav-module-config';
import { environment } from '@environment';

export const NavConfigOverride: INavModuleConfig = {
    hasKeyboardShortcutsModule: false,
    showKeyboardShortcutsButton: false,
    siteName: environment.siteName || null,
    submitHelpUrl: environment.submitHelpUrl || null,
};
